<template>
  <div style="height: 100%;">
    <div class="question">{{ question.texts[lang] }}</div>
    <div class="answer">La bonne réponse était: Blanc</div>
    <div class="results">
      <div class="winners">
        <podium-big-step
          v-bind="{position, user: users[position-1]}"
          :class="`pos-${position}`"
          v-for="position in [2, 1, 3]"
          :key="position"
        ></podium-big-step>
      </div>
      <div class="others">
        <podium-step
          v-bind="{position: index + 4, user }"
          class="other"
          v-for="(user, index) in users.slice(3)"
          :key="index+3"
        ></podium-step>
      </div>
    </div>
  </div>
</template>

<script>
import CommonMixin from '../mixins/common.js';
// import Question from '../components/Question.vue';
import PodiumBigStep from '@/components/podium/BigStep.vue';
import PodiumStep from '@/components/podium/Step.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'podium',
  components: {
    PodiumBigStep,
    PodiumStep
  },
  props: { ...CommonMixin.props },
  data: () => ({
    users: [
      { name: 'Romain  Baumier', email: 'rb@livee.com', phone: '06 12 34 56 78' },
      { name: 'Jérémy Litaize', email: 'jl@livee.com', phone: '06 12 34 56 78' },
      { name: 'Nathan Grimaud', email: 'ng@livee.com', phone: '06 12 34 56 78' },
      { name: 'Alexis Rouillard', email: 'ar@livee.com', phone: '06 12 34 56 78' },
      { name: 'Alexandre Vilain', email: 'av@livee.com', phone: '06 12 34 56 78' },
      { name: 'MK Simon', email: 'mks@livee.com', phone: '06 12 34 56 78' },
      { name: 'Valentin  Renard', email: 'vr@livee.com', phone: '06 12 34 56 78' }
    ]
  }),
  computed: {
    ...mapGetters({ lang: 'getInputLanguage' }),
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.results {
  width: 70%;
  margin-left: auto;
  margin-right: auto;
  height: calc(100% - 180px);
  max-height: 700px;
  margin-top: 50px;
  display: flex;
  flex-direction: column;
}

.question {
  text-align: center;
  background-color: #3f8ec4;
  color: white;
  font-size: 40px;
  font-weight: 100;
  padding: 10px;
}

.answer {
  text-align: center;
  font-size: 30px;
  margin: 10px;
}

.winners {
  display: flex;
  height: 100%;
  flex-grow: 1;

  div {
    flex-grow: 1;
    bottom: 0;
    margin: 0 5px 0 5px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}

.others {
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  margin-bottom: 20px;

  .other {
    flex-grow: 1;
    flex-basis: 48%;
    margin: 20px 5px 0 5px;
  }
}
</style>
